import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const navigate = useNavigate();
  const { updateUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.replace('#', ''));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          navigate('/login', { replace: true });
          return;
        }

        // Exchange session_id for session token via backend
        const { data } = await axios.post(`${API}/auth/google/session`, {
          session_id: sessionId
        }, { withCredentials: true });

        // Store access token
        if (data.access_token) {
          localStorage.setItem('access_token', data.access_token);
        }

        // Update auth context
        updateUser(data.user);

        // Clean the URL and redirect
        window.history.replaceState(null, '', window.location.pathname);

        // Navigate to app (or profile setup if new user)
        if (data.user.profile_complete) {
          navigate('/app', { replace: true, state: { user: data.user } });
        } else {
          navigate('/app/profile/setup', { replace: true, state: { user: data.user } });
        }
      } catch (e) {
        console.error('Google auth failed:', e);
        navigate('/login', { replace: true });
      }
    };

    processSession();
  }, [navigate, updateUser]);

  return (
    <div className="min-h-screen bg-[#050505] flex flex-col items-center justify-center">
      <Loader2 className="w-10 h-10 text-rose-500 animate-spin mb-4" />
      <p className="text-zinc-400">Signing you in...</p>
    </div>
  );
}
